// components/modals/PasswordModals/DeletePasswordModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../../../styles/components/modals.css';
import useModalHistory from '../../../hooks/useModalHistory';

const DeletePasswordModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  passwordName,
  isSingle = true,
  isLoading = false 
}) => {
    useModalHistory(show, onHide, 'password-delete-modal');
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="common-modal"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="delete-confirmation">
          <div className="warning-icon mb-3">
            <i className="fas fa-exclamation-triangle"></i>
          </div>
          
          {isSingle ? (
            <p>
              Are you sure you want to delete the password <strong>{passwordName}</strong>?
              <br />
              This action cannot be undone.
            </p>
          ) : (
            <p>
              Are you sure you want to delete the selected passwords?
              <br />
              This action cannot be undone.
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className="modal-close-btn">
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={onConfirm} 
          disabled={isLoading}
          className="delete-btn"
        >
          {isLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePasswordModal;